


























































































































import Vue from "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import config from "@/configs";
import AccountCardContent from "@/components/AccountCardContent.vue";
import CustomerCardContent from "@/components/CustomerCardContent.vue";
import { ConfigMode } from "@/enums/config.enum";

export default Vue.extend({
  name: "LandingCard",
  components: { CustomerCardContent, AccountCardContent },
  data: (): any => {
    return {
      ConfigMode,
      mode: null,
      company: config?.settings.company,
      isEmailSent: false,
      attrs: {
        class: "mb-3",
        elevation: 2,
        loading: true,
      },
    };
  },
  computed: {
    ...mapGetters("auth", {
      loading: "getLoading",
    }),
    ...mapGetters("auth", [
      "getUserAccounts",
      "getAuthInitials",
      "getAuthDisplayName",
      "getAuthEmail",
      "getLoadingSession",
      "getLoadingEmailLink",
      "getAuthEmailVerified",
    ]),
    ...mapGetters("snackbar", ["getVisibility"]),
  },
  methods: {
    ...mapActions("auth", ["logout", "verifyEmailLink"]),
    async doVerifyEmail() {
      this.verifyEmailLink().then((value: boolean) => {
        this.isEmailSent = value;
      });
    },
    ...mapMutations("snackbar", ["setVisibility"]),
  },
  created() {
    if (config?.settings.mode) {
      this.mode = config?.settings.mode;
    } else {
      this.mode = ConfigMode.PLATFORM;
    }
  },
});
